import { useState } from "react";
import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { checklistTasks } from "./checklistTasks";
import { useOnboardingStore } from "../useOnboardingStore";
import { trackOnboarding } from "../analytics";
import ChecklistPanel from "./ChecklistPanel";

/**
 * Floating getting-started pill. Bottom-LEFT — the Tawk chat bubble owns
 * bottom-right. Hidden on small screens (mobile carousel + Tawk crowding) and
 * once every task is complete. Mounted only via OnboardingGate (main window,
 * never popouts).
 */
export default function ChecklistLauncher() {
  const [open, setOpen] = useState(false);
  const tasks = useOnboardingStore((s) => s.state?.checklist?.tasks ?? {});

  const doneCount = checklistTasks.filter((t) => tasks[t.id]).length;
  const total = checklistTasks.length;

  if (doneCount >= total) return null;

  const toggle = () => {
    if (!open) trackOnboarding("checklist_opened");
    setOpen((v) => !v);
  };

  return (
    <div className="fixed bottom-4 left-4 z-[90] hidden sm:block no-drag">
      {open && (
        <div className="mb-2">
          <ChecklistPanel onNavigate={() => setOpen(false)} />
        </div>
      )}
      <button
        type="button"
        onClick={toggle}
        className="flex items-center gap-2 rounded-full border border-gray-700 bg-gray-800 py-2 pl-3 pr-4 text-sm font-medium text-gray-200 shadow-lg hover:border-squawk-blue/60 hover:text-white transition-colors cursor-pointer"
        aria-expanded={open}
      >
        <ClipboardDocumentCheckIcon className="h-4 w-4 text-squawk-blue" />
        Getting started
        <span className="rounded-full bg-squawk-blue/20 px-1.5 py-0.5 text-xs font-semibold text-squawk-blue">
          {doneCount}/{total}
        </span>
      </button>
    </div>
  );
}
